(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FitBuilderViator',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load() 
	{
		var $destination_id = $('#fitbuilderviator-destination_id'),
			$tag_select     = $('#fitbuilderviator-tag_ids');

		Adzuki.Typeahead(
			'.destination-search',
			'/Viator/destinationSearch',
			function selectDestination(item) {
				$destination_id.val(item.destination_id);

				getTagsForDestination(item.destination_id);

				$('.destination-search').prop('disabled', true);
				$('.reset-destination').removeClass('hidden');
			}
		);

		$('.fb-viator-search').click(function _getResults(e) {
			var $fb_viator_form_data = $('#fb-viator-form').serialize();

			e.preventDefault();

			$('.fb-viator-results').html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin fa-2x"></i>&nbsp;Loading tours...');

			Adzuki.Ajax.post('/FitBuilders/viatorSearch', $fb_viator_form_data)
			.then(function _getRoomToken(response) {
				$('.fb-viator-results').css('height', '400px');
				$('.fb-viator-results').html(response);

				$('.fb-viator-clear').removeClass('hidden');
			});
		});

		$('.fb-viator-form-field').keypress(function runSearch(e) {
			var keycode = (e.keyCode ? e.keyCode : e.which);

			if (keycode === 13) {
				$('.fb-viator-search').trigger('click');
			}
		});

		$('.reset-destination').click(function _resetDestination(e) {
			e.preventDefault();
			resetDestination();
		});

		$('.fb-viator-clear').click(function _viatorClear(e) {
			e.preventDefault();

			$('.fb-viator-results').css('height', 'auto');
			$('.fb-viator-results').html('');

			clearTagSelect();
			resetDestination();
			$('.fb-viator-clear').addClass('hidden');
		});

		$('.fb-viator-results').on('click', '.fb-viator-details', function _setDetails(e) {
			e.preventDefault();

			$('#fitbuilderexcursion-excursion_name').val($(this).data('name'));
			$('#fitbuilderexcursion-port').val($(this).data('location'));
			$('#fitbuilderexcursion-details').val($(this).data('description'));
			$('#fitbuilderexcursion-duration').val($(this).data('duration'));
			$('#fit-builder-excursion-image').val($(this).data('image'));
			$('#fit-builder-viator-price').val($(this).data('price'));

			toastr.success(
				null,
				'Details added to form',
				{
					positionClass  : 'toast-top-center',
					timeOut        : 3000,
					extendedTimeOut: 0,
				}
			);
		});

		function getTagsForDestination(destination_id)
		{
			var tags = [];

			Adzuki.Ajax.get('/Viator/tagsByDestination/' + destination_id)
			.then(function gotTags(tag_options) {
				var sorted = Adzuki.Sort.alphabeticValue(tag_options);

				$.each(sorted, function loopTags(sKey, sValue) {
					tags.push($('<option>').text(sValue.value).attr('value', sValue.key));
				});

				clearTagSelect();
				$tag_select.append(tags);
				$tag_select.selectpicker('refresh');
			});
		}

		function clearTagSelect()
		{
			$tag_select.empty();
			$tag_select.selectpicker('refresh');
		}

		function resetDestination()
		{
			$('.destination-search').val('');
			$('.destination-search').prop('disabled', false);

			$(this).addClass('hidden');
		}
	};

}(jQuery, window.Adzuki || {}));
